import {Injectable, signal} from '@angular/core';
import {FileSortField, FileTypes, SortType} from 'src/app/pages/apps/file/file';
import {fileUploadData} from 'src/app/pages/apps/file/fileUploadData';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  public fileUploadOptions = signal<FileTypes[]>(fileUploadData);

  protected constructor(private http: HttpClient) {
  }

  public getFileUploadOptions(): FileTypes[] {
    return this.fileUploadOptions();
  }

  getUsersFileOperationDecisions(organizationId: number){
    return this.http
      .get(`${environment.apiUrl}organisation-resource-setting/by-organisation/${organizationId}`)
  }

  getMaxFileSize(){
    return this.http.get(`${environment.apiUrl}organisation-resource-setting/max-file-size`, {
      responseType: 'text'
    });
  }


  // data can contains name and organization
  getFilesInformation(organisationId: number, data: object, page: number = 1, size: number = 10, sortField: FileSortField = FileSortField.ID, sortType: SortType = SortType.DESC){
    return this.http
      .post(`${environment.apiUrl}file-metadata/filter?organisationId=${organisationId}&page=${page}&size=${size}&sortField=${sortField}&sortType=${sortType}`, data)
  }

  sendFile(data: object){
    return this.http
      .post(`${environment.apiUrl}knowledge-base/upload-file`, data)
  }

  getFileToken(organisationId: number, s3Key: string) {
    return this.http
      .get(`${environment.apiUrl}file-service/get-file-token?organisationId=${organisationId}&s3Key=${s3Key}`)
  }

  viewFile(organisationId: number, accessToken: string) {
    return this.http
      .get(`${environment.apiUrl}file-service/view-file?organisationId=${organisationId}&accessToken=${accessToken}`, {
        responseType: 'blob',
        observe: 'response'
      })
  }

  downloadFile(organisationId: number, accessToken: string) {
    return this.http
      .get(`${environment.apiUrl}file-service/download-file?organisationId=${organisationId}&accessToken=${accessToken}`, {
        responseType: 'blob'
      })
  }

  removeFile(organisationId: number, s3Key: string, fileId: number) {
    return this.http
      .delete(`${environment.apiUrl}knowledge-base/delete-file?fileId=${fileId}&s3Key=${s3Key}&organisationId=${organisationId}`);
  }

  getScraperFileAsMarkdown(organisationId: number, fileId: number) {
    return this.http
      .get(`${environment.apiUrl}file-service/get-scraper-file-as-markdown?organisationId=${organisationId}&fileId=${fileId}`, {
        responseType: 'text'
      })
  }
}
